import { type ComponentPropsWithoutRef, forwardRef, useMemo } from 'react';
import { TextArea as ZusTextArea } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { cn } from '@/utils';
type PromptAttachmentType = 'file' | 'youtube' | 'website' | 'none';
export const TextArea = forwardRef<HTMLTextAreaElement, Omit<ComponentPropsWithoutRef<'textarea'>, 'value'> & {
  value?: string;
  attachmentType: PromptAttachmentType;
}>(({
  attachmentType,
  className,
  ...rest
}, ref) => {
  const {
    t
  } = useTranslation(['build']);
  const placeholder = useMemo(() => {
    if (attachmentType === 'none') {
      return t('build:ai.prompt.placeHolder');
    }
    return t('build:ai.prompt.placeHolderWithAttachment');
  }, [attachmentType, t]);
  return <ZusTextArea.InputField ref={ref} className={cn('w-full grow', 'leading-[1.3] text-default placeholder-gray-400 resize-none', 'text-[18px] font-bold', className)} placeholder={placeholder} {...rest} />;
});
TextArea.displayName = 'TextArea';